import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-1 text-left text-xs text-red-600" }

import { ref } from 'vue';

import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: {
    error: {}
  },
  setup(__props: any) {



const type = ref<'password' | 'text'>('password');

function toggleType() {
  if (type.value === 'password') {
    type.value = 'text';

    return;
  }

  type.value = 'password';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["block text-left", _ctx.$attrs.class])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(IconField), _mergeProps(_ctx.$attrs, {
      class: "mt-1 block w-full",
      invalid: !!_ctx.error
    }), {
      default: _withCtx(() => [
        _createVNode(_unref(InputText), _mergeProps({ class: "w-full" }, _ctx.$attrs, {
          size: "small",
          type: type.value
        }), null, 16, ["type"]),
        _createVNode(_unref(InputIcon), {
          class: _normalizeClass(["cursor-pointer", {
          'pi pi-eye-slash': type.value === 'password',
          'pi pi-eye': type.value === 'text',
        }]),
          onClick: toggleType
        }, null, 8, ["class"])
      ]),
      _: 1
    }, 16, ["invalid"]),
    _createElementVNode("small", _hoisted_1, _toDisplayString(_ctx.error), 1)
  ], 2))
}
}

})